export const ChangeColor = (prop) => {
    var Stage = prop
    var stagecolor = ""
    if(Stage === ""){
        stagecolor = "#F44336"
    }
    if (Stage === -1) {
        stagecolor = "#aaa";
    }
    else if (Stage === 0) {
        stagecolor = "#F44336";
    }
    else if (Stage === 1) {
        stagecolor = "#FFB700";
    }
    else if (Stage === 2) {
        stagecolor = "#26C6DA";
    }
    else if (Stage === 3) {
        stagecolor = "#9CCC65";
    }

    return stagecolor
}